import React from 'react'
import Page500 from "./Page500";
import Page400 from "./Page400";
import Page403 from "./Page403";

const ErrorPage = (props) => {

    if (props.responseCode && props.responseCode === 500) {
        return (
            <Page500/>
        )
    } else if (props.responseCode && props.responseCode === 400) {
        return (
            <Page400 message={props.message}/>
        )

    } else if (props.responseCode && props.responseCode === 403) {
        return (
          <Page403 message={props.message}/>
        )
    }

    return (
        <div className="text-danger">
            {{error: props.responseCode}} {props.message}
        </div>
    )
}

ErrorPage.defaultProps = {
    message: "Could not connect to API",
    responseCode: null
}

export default ErrorPage
